/** @file Renames a skin (ASCII name, unique among skins); its current name is a no-op. */
import { defineRename } from '../_shared/defineRename';
import { defineCommand } from '../defineCommand';

const factory = defineRename({ domain: 'skin', kind: 'skin', description: 'Rename a skin (ASCII name, unique among skins).' });

/** skin.rename: the defineRename factory; renaming a skin to its own name writes nothing (R2-13). */
export const command = defineCommand({
  ...factory,
  apply(draft, input, ctx) {
    if (draft.skins[ctx.resolve('skin', input.target)]?.name === input.name) return;
    factory.apply(draft, input, ctx);
  },
});
